import * as userActions from 'redux/actions/user.actions'
import * as accountActions from 'redux/actions/account.actions'
import * as actions from 'redux/actions/reports.actions'
import { hasPropertyChain } from 'helpers/util'
import { sortData } from 'helpers/sortData'

const initialState = {
  dataLoadedAt: null,
  reports: {
    previous: {}
  },
  loading: false,
  domains: []
}

const addReports = (reports, { type, payload = {} }) => {
  switch (type) {
    case actions.loadReportsSuccess.type:
      return {
        ...reports,
        [payload.domainId]: payload.reports
      }
    case actions.loadPreviousReportsSuccess.type:
      return {
        ...reports,
        previous: {
          ...reports.previous,
          [payload.domainId]: {
            ...reports.previous[payload.domainId],
            [payload.reportId]: payload.previousReports.attributes.reports
          }
        }
      }
    case actions.createReportSuccess.type:
      return {
        ...reports,
        [payload.domainId]: [...reports[payload.domainId], payload.report]
      }
    default:
      return reports
  }
}

const updateReport = (reports, { type, payload = {} }) => {
  switch (type) {
    case actions.updateReportSuccess.type:
      return [...reports.map(report => (payload.reportId === report.id ? payload.report : report))]
    default:
      return reports
  }
}

const reportsReducer = (state = initialState, { type, payload = {} }) => {
  switch (type) {
    case actions.loadDomains.type:
      return {
        ...state,
        loading: true,
        domains: initialState.domains
      }
    case actions.loadDomainsSuccess.type:
      return {
        ...state,
        loading: false,
        domains: payload.domains
      }
    case actions.sortDomainsReports.type: {
      const value = payload.value
      const order = payload.order
      switch (true) {
        case value === 'Sort by':
          state.domains.sort(sortData(['attributes', 'createdAt'], order, value))
          break
        case value === 'A-Z':
          state.domains.sort(sortData(['attributes', 'host'], order, value))
          break
        case value === 'Reports' && order === 'ascending':
          state.domains.sort((a, b) => a.data.length - b.data.length)
          break
        case value === 'Reports' && order === 'descending':
          state.domains.sort((a, b) => b.data.length - a.data.length)
          break
        case value === 'Active' && order === 'ascending':
          state.domains.sort(
            (a, b) =>
              a.data.map(active => active.attributes.status).filter(active => active).length -
              b.data.map(active => active.attributes.status).filter(active => active).length
          )
          break
        case value === 'Active' && order === 'descending':
          state.domains.sort(
            (a, b) =>
              b.data.map(active => active.attributes.status).filter(active => active).length -
              a.data.map(active => active.attributes.status).filter(active => active).length
          )
          break
        default:
          return state.domains
      }
      return {
        ...state,
        domains: [...state.domains]
      }
    }
    case actions.loadReportsSuccess.type:
    case actions.createReportSuccess.type:
      if (!hasPropertyChain(state, 'reports', payload.domainId)) {
        state.reports[payload.domainId] = []
        state.reports.previous[payload.domainId] = []
      }

      return {
        ...state,
        dataLoadedAt: new Date(),
        reports: {
          ...addReports(state.reports, { type, payload })
        }
      }

    case actions.loadPreviousReportsSuccess.type:
      if (!hasPropertyChain(state, 'reports', payload.domainId)) {
        state.reports[payload.domainId] = []
        state.reports.previous[payload.domainId] = {}
      }

      if (!hasPropertyChain(state, 'reports', 'previous', payload.domainId, payload.reportId)) {
        state.reports.previous[payload.domainId][payload.reportId] = []
      }

      return {
        ...state,
        dataLoadedAt: new Date(),
        reports: {
          ...addReports(state.reports, { type, payload })
        }
      }

    case actions.updateReportSuccess.type: {
      let updateDomainReports = state.reports[payload.domainId].filter(
        report => payload.id !== report.id
      )
      return {
        ...state,
        dataLoadedAt: new Date(),
        reports: {
          ...state.reports,
          [payload.domainId]: updateReport(updateDomainReports, { type, payload })
        }
      }
    }
    case actions.deleteReportSuccess.type: {
      let deleteDomainReports = state.reports[payload.domainId].filter(
        report => payload.id !== report.id
      )

      return {
        ...state,
        reports: {
          ...state.reports,
          [payload.domainId]: deleteDomainReports
        }
      }
    }
    case actions.downloadPrevious.type:
      return {
        ...state,
        reports: {
          ...state.reports,
          previous: {
            [payload.domainId]: {
              [payload.reportId]: state.reports.previous[payload.domainId][payload.reportId].map(
                report => {
                  if (payload.id === report.data.id) {
                    report.data.loading = true
                  }
                  return report
                }
              )
            }
          }
        }
      }
    case accountActions.getAccountDataFailure.type:
    case userActions.logout.type:
      return initialState
    default:
      return state
  }
}

export default reportsReducer
